import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import { InlineText1 } from '@cian/ui-kit/typography';
import { ICoworkingAmenityNames } from '@cian/api-models/offer-card/v1/get-offer-data';

import { coworkingAmenitiesIcons } from '../../constants/coworkingAmenitiesIcons';

const styles = require('./CoworkingAmenity.css');

interface ICoworkingAmenity {
  keyName: ICoworkingAmenityNames;
  title: string;
  className?: string;
}

export function CoworkingAmenity({ keyName, title, className }: ICoworkingAmenity) {
  const icon = coworkingAmenitiesIcons[keyName];

  return (
    <div {...mergeStyles(styles['root'], className)}>
      <span className={styles['icon']}>{icon}</span>
      <InlineText1>{title}</InlineText1>
    </div>
  );
}
